import React, { Component } from 'react';
import InputFieldComponent from './InputFieldComponent';
import { email, length } from 'redux-form-validators';
import _ from 'lodash';
import { EMAIL_LENGTH } from '../../constants/form';
import format from 'string-template';

class EmailInputFieldComponent extends Component {
    validateMandatory = () => [
        email({
            msg: this.props.i18nFeatureForm.EMAIL_INVALID,
            allowBlank: !this.props.isRequired
        }),
        length({
            max: EMAIL_LENGTH,
            msg: format(
                this.props.i18nFeatureForm.EMAIL_TOOLONG,
                EMAIL_LENGTH,
                EMAIL_LENGTH > 1 ? 's' : ''
            )
        }),
        ..._.toArray(this.props.validate)
    ];

    render() {
        return (
            <InputFieldComponent {...this.props} type="email" validate={this.validateMandatory()} />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props

export default EmailInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/EmailInputFieldComponent.js